import { render, staticRenderFns } from "./ParetoChart.vue?vue&type=template&id=a7374748&"
import script from "./ParetoChart.vue?vue&type=script&lang=js&"
export * from "./ParetoChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports